import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {AuthProvider} from "./contexts/AuthContext";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <AuthProvider>
            <App/>
        </AuthProvider>
    </React.StrictMode>
);

// Bật lại transition sau khi vẽ xong lần đầu để tránh hiệu ứng "phai màu" lúc tải trang
requestAnimationFrame(() => {
    requestAnimationFrame(() => document.body.classList.remove('preload-transitions'));
});